import metronome from '../elements/metronome.js';
metronome.register();
